import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import ClearIcon from "@mui/icons-material/Clear";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  Autocomplete,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  SnackbarContent,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Box, Stack } from "@mui/system";
import { PageGroupEndPointLogic } from "../../../../../logic/AssetManagement/PageGroups/pageGroupEndPointLogic";
import { useSelector } from "react-redux";
import {
  selectIsLoading,
  selectUserToken,
  setIsLoading,
} from "../../../../../features/userSlice";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import { sitePageEndPointLogic } from "../../../../../logic/AssetManagement/PageManagement/SitePages/sitePagesEndPointLogic";

import { useSearchParams } from "react-router-dom";

interface CreateNewRequestModalProps {
  openModal: boolean;
  handleClose: () => void;
  pageContent: any;
  setOpenModal: any;
  setPageRefreshStatus: any;
  setPreview: any;
}

export default function EditPageModal({
  openModal,
  pageContent,
  setOpenModal,
  setPageRefreshStatus,
  setPreview,
}: CreateNewRequestModalProps) {
  const [pageTitle, setPageTitle] = useState([]) as any;
  const userToken = useSelector(selectUserToken);
  const [pageGroup, setPageGroup] = useState([]) as any;
  type DeviceType = "desktop" | "tablet" | "mobile";
  const isLoading = useSelector(selectIsLoading);

  //Implemented Switch Concept
  interface SwitchStates {
    desktopHeadline: boolean;
    desktopImage: boolean;
    tabletHeadline: boolean;
    tabletImage: boolean;
    mobileHeadline: boolean;
    mobileImage: boolean;
  }

  const [switchStates, setSwitchStates] = useState({
    desktopHeadline: false,
    desktopImage: false,
    tabletHeadline: false,
    tabletImage: false,
    mobileHeadline: false,
    mobileImage: false,
  });

  const devices: DeviceType[] = ["desktop", "tablet", "mobile"];

  const [selectedPageGroupValue, setSelectedPageGroupValue] = useState(
    pageGroup.find(
      (option: any) => option.shared_uid === pageContent?.page_group
    ) || null
  );
  const [headlineState, setHeadlineState] = useState({
    desktop:
      pageContent?.headlines?.desktop_inheritance !== null
        ? "inherit"
        : "custom",
    mobile:
      pageContent?.headlines?.mobile_inheritance !== null
        ? "inherit"
        : "custom",
    tablet:
      pageContent?.headlines?.tablet_inheritance !== null
        ? "inherit"
        : "custom",
  }) as any;

  const [bannerState, setbannerState] = useState({
    desktop:
      pageContent?.banners?.desktop_inheritance !== null ? "inherit" : "custom",
    mobile:
      pageContent?.banners?.mobile_inheritance !== null ? "inherit" : "custom",
    tablet:
      pageContent?.banners?.tablet_inheritance !== null ? "inherit" : "custom",
  }) as any;

  const [headlineCustomValue, setHeadlineCustomValue] = useState({
    desktop:
      pageContent?.headlines?.desktop_inheritance === null
        ? pageContent?.headlines?.desktop
        : "",
    mobile:
      pageContent?.headlines?.mobile_inheritance === null
        ? pageContent?.headlines?.mobile
        : "",
    tablet:
      pageContent?.headlines?.tablet_inheritance === null
        ? pageContent?.headlines?.tablet
        : "",
  }) as any;

  const [base64Images, setBase64Images] = useState<{
    [key: string]: string | null;
  }>({
    desktop:
      pageContent?.banners?.desktop_inheritance === null
        ? pageContent?.banners?.desktop
        : "",
    mobile:
      pageContent?.banners?.mobile_inheritance === null
        ? pageContent?.banners?.mobile
        : "",
    tablet:
      pageContent?.banners?.tablet_inheritance === null
        ? pageContent?.banners?.tablet
        : "",
  }) as any;

  const [bannerImagePathDesktop, setBannerImagePathDesktop] = useState(
    bannerState["desktop"] === "custom" ? pageContent?.banners?.desktop : ""
  );
  const [bannerImagePathMobile, setBannerImagePathMobile] = useState(
    bannerState["mobile"] === "custom" ? pageContent?.banners?.mobile : ""
  );
  const [bannerImagePathTablet, setBannerImagePathTablet] = useState(
    bannerState["tablet"] === "custom" ? pageContent?.banners?.tablet : ""
  );
  const [pageURL, setPageURL] = useState("");
  const [uploadingDevice, setUploadingDevice] = useState("");
  const [imagePath, setImagePath] = useState("");

  const [metaUpdateStart, setMetaUpdateStart] = useState(false);
  const [searchParams] = useSearchParams();
  const selectedSite = searchParams.get("selectedSite") || "";

  useEffect(() => {
    if (!pageContent) return; // Avoid running if pageContent is undefined

    setHeadlineState({
      desktop:
        pageContent.headlines?.desktop_inheritance !== null
          ? "inherit"
          : "custom",
      mobile:
        pageContent.headlines?.mobile_inheritance !== null
          ? "inherit"
          : "custom",
      tablet:
        pageContent.headlines?.tablet_inheritance !== null
          ? "inherit"
          : "custom",
    });

    setbannerState({
      desktop:
        pageContent.banners?.desktop_inheritance !== null
          ? "inherit"
          : "custom",
      mobile:
        pageContent.banners?.mobile_inheritance !== null ? "inherit" : "custom",
      tablet:
        pageContent.banners?.tablet_inheritance !== null ? "inherit" : "custom",
    });

    setHeadlineCustomValue({
      desktop:
        pageContent.headlines?.desktop_inheritance === null
          ? pageContent.headlines?.desktop || ""
          : "",
      mobile:
        pageContent.headlines?.mobile_inheritance === null
          ? pageContent.headlines?.mobile || ""
          : "",
      tablet:
        pageContent.headlines?.tablet_inheritance === null
          ? pageContent.headlines?.tablet || ""
          : "",
    });

    setBase64Images({
      desktop:
        pageContent.banners?.desktop_inheritance === null
          ? pageContent.banners?.desktop || ""
          : "",
      mobile:
        pageContent.banners?.mobile_inheritance === null
          ? pageContent.banners?.mobile || ""
          : "",
      tablet:
        pageContent.banners?.tablet_inheritance === null
          ? pageContent.banners?.tablet || ""
          : "",
    });

    setBannerImagePathDesktop(
      pageContent.banners?.desktop_inheritance === null
        ? pageContent.banners?.desktop || ""
        : ""
    );
    setBannerImagePathMobile(
      pageContent.banners?.mobile_inheritance === null
        ? pageContent.banners?.mobile || ""
        : ""
    );
    setBannerImagePathTablet(
      pageContent.banners?.tablet_inheritance === null
        ? pageContent.banners?.tablet || ""
        : ""
    );
    setPageURL(pageContent?.post_url?.split("/").filter(Boolean).pop());

    // not staying in orginal switch state problem fixed with this changes
    setSwitchStates({
      desktopHeadline: pageContent.headlines?.desktop_inheritance === null,
      desktopImage: pageContent.banners?.desktop_inheritance === null,
      tabletHeadline: pageContent.headlines?.tablet_inheritance === null,
      tabletImage: pageContent.banners?.tablet_inheritance === null,
      mobileHeadline: pageContent.headlines?.mobile_inheritance === null,
      mobileImage: pageContent.banners?.mobile_inheritance === null,
    });
  }, [openModal, pageContent]);

  const metaData = {
    data: {
      post_status: pageContent?.post_status,
      post_title: pageTitle,
      headlines: {
        mobile:
          headlineState?.mobile === "custom"
            ? headlineCustomValue?.mobile
            : null,
        tablet:
          headlineState?.tablet === "custom"
            ? headlineCustomValue?.tablet
            : null,
        desktop:
          headlineState?.desktop === "custom"
            ? headlineCustomValue?.desktop
            : null,
      },
      banners: {
        mobile:
          bannerState?.mobile === "inherit" ? null : bannerImagePathMobile,
        tablet:
          bannerState?.tablet === "inherit" ? null : bannerImagePathTablet,
        desktop:
          bannerState?.desktop === "inherit" ? null : bannerImagePathDesktop,
      },
      new_url: pageURL,
    },
  };

  const pageGroupData = {
    data: { page_group_id: selectedPageGroupValue?.shared_uid },
  };

  const imageUploadData = {
    data: {
      base64_image:
        uploadingDevice === "desktop"
          ? base64Images.desktop?.base64
          : uploadingDevice === "mobile"
          ? base64Images.mobile?.base64
          : base64Images.tablet?.base64,
      file_name:
        uploadingDevice === "desktop"
          ? base64Images.desktop?.fileName
          : uploadingDevice === "mobile"
          ? base64Images.mobile?.fileName
          : base64Images.tablet?.fileName,
    },
  };

  useEffect(() => {
    const uploadImage = async () => {
      if (uploadingDevice && base64Images[uploadingDevice]?.base64) {
        try {
          await PageGroupEndPointLogic.postImageUpload(
            userToken,
            selectedSite,
            setImagePath,
            imageUploadData
          );
        } catch (error) {
          console.error("Image upload failed:", error);
        } finally {
          setBase64Images({
            desktop: null,
            mobile: null,
            tablet: null,
          });
        }
      }
    };
    uploadImage();
    // eslint-disable-next-line
  }, [base64Images, uploadingDevice]);

  useEffect(() => {
    if (uploadingDevice === "desktop") {
      setBannerImagePathDesktop(imagePath);
    }
    if (uploadingDevice === "mobile") {
      setBannerImagePathMobile(imagePath);
    }
    if (uploadingDevice === "tablet") {
      setBannerImagePathTablet(imagePath);
    }
    // eslint-disable-next-line
  }, [imagePath, uploadingDevice]);

  useEffect(() => {
    // Initialize other states
    setPageTitle(pageContent.post_title);
    setSelectedPageGroupValue(
      pageGroup.find(
        (option: any) => option.shared_uid === pageContent?.page_group
      ) || null
    );

    // Fetch page groups
    PageGroupEndPointLogic.getAllPageGroups(
      String(userToken),
      selectedSite,
      setPageGroup
    );
    // eslint-disable-next-line
  }, [openModal === true]);

  const handleCancel = () => {
    setOpenModal(false);
    setHeadlineState({
      desktop: "inherit",
      mobile: "inherit",
      tablet: "inherit",
    });
    setbannerState({
      desktop: "inherit",
      mobile: "inherit",
      tablet: "inherit",
    });
    setHeadlineCustomValue({
      desktop: "",
      mobile: "",
      tablet: "",
    });
    setBase64Images({
      desktop: null,
      mobile: null,
      tablet: null,
    });
    setBannerImagePathDesktop("");
    setBannerImagePathMobile("");
    setBannerImagePathTablet("");
  };

  const handleTextChange = (device: string, value: any) => {
    setHeadlineCustomValue((prevState: any) => ({
      ...prevState,
      [device]: value,
    }));
  };

  const handleFileUpload = (
    device: string,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      const fileNameWithoutExtension = file.name.replace(
        /\.(png|webp|jpg|jpeg|gif)$/i,
        ""
      );
      reader.onloadend = () => {
        setBase64Images((prevState: any) => ({
          ...prevState,
          [device]: {
            base64: reader.result as string, // Store the base64 image
            fileName: fileNameWithoutExtension, // Store the file name
          },
        }));
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please upload a valid image file.");
    }
  };

  useEffect(() => {
    const updatePageMeta = async () => {
      setPageRefreshStatus(false);
      if (metaUpdateStart === true) {
        try {
          await sitePageEndPointLogic.updatePageMeta(
            metaData,
            selectedSite,
            pageContent?.shared_uid,
            setIsLoading,
            String(userToken),
            setPageRefreshStatus,
            setPreview
          );
          if (selectedPageGroupValue?.shared_uid !== pageContent?.page_group) {
            sitePageEndPointLogic.updatePageMeta(
              pageGroupData,
              selectedSite,
              pageContent?.shared_uid,
              setIsLoading,
              String(userToken),
              setPageRefreshStatus,
              setPreview
            );
          }
        } catch (error) {
          console.error("Error creating page group:", error);
        } finally {
          setMetaUpdateStart(false);
          setPageRefreshStatus(true);
          handleCancel();
        }
      }
    };
    updatePageMeta();
    // eslint-disable-next-line
  }, [metaUpdateStart]);

  const handleToggle =
    (field: keyof SwitchStates) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const isCustom = event.target.checked;
      const fieldName = field.toString();

      // Determine if it's a headline or image toggle and get the device key
      const isHeadline = fieldName.includes("Headline");
      const device = fieldName.replace("Headline", "").replace("Image", "");

      setSwitchStates((prev) => ({
        ...prev,
        [field]: isCustom,
      }));

      if (isHeadline) {
        setHeadlineState((prev: any) => ({
          ...prev,
          [device]: isCustom ? "custom" : "inherit",
        }));
      } else {
        setbannerState((prev: any) => ({
          ...prev,
          [device]: isCustom ? "custom" : "inherit",
        }));
      }
    };

  return (
    <>
      <Dialog open={openModal} onClose={handleCancel} fullWidth maxWidth="md">
        {isLoading && <SimpleBackdrop />}
        <Box
          sx={{
            maxHeight: "780px",
            overflowY: "auto",
            scrollbarWidth: "thin",
          }}
        >
          <DialogTitle id="customized-dialog-title">Edit Page Meta</DialogTitle>
          <DialogContent sx={{ overflow: "visible" }}>
            {/* First part details */}
            <Grid container spacing={2}>
              {/* Page Name TextField */}
              <Grid size={12}>
                <TextField
                  fullWidth
                  size="small"
                  label="Page Title"
                  value={pageTitle}
                  onChange={(e) => {
                    setPageTitle(e.target.value);
                  }}
                  color="secondary"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              </Grid>
              {/* Page Group Autocomplete */}
              <Grid size={6}>
                <TextField
                  fullWidth
                  size="small"
                  label="Page URL"
                  color="secondary"
                  value={pageURL}
                  onChange={(e) => setPageURL(e.target.value)}
                />
              </Grid>
              <Grid size={6}>
                <Autocomplete
                  fullWidth
                  disablePortal
                  options={pageGroup.filter(
                    (group: any) => group.active === true
                  )}
                  getOptionLabel={(option) =>
                    typeof option === "string"
                      ? option
                      : option.group_name || ""
                  }
                  value={selectedPageGroupValue}
                  onChange={(_, newValue) => {
                    setSelectedPageGroupValue(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Page Group"
                      color="secondary"
                    />
                  )}
                />
              </Grid>
            </Grid>
            {/* Warning message */}
            <Stack mt={2}>
              <SnackbarContent
                sx={{
                  background: "#E5F6FD",
                  color: "#014361",
                  boxShadow: "none",
                  padding: "0 16px",
                }}
                message={
                  <Box display="flex">
                    <ErrorOutlineIcon
                      sx={{ marginRight: "8px", color: "#0288D1" }}
                    />
                    <Box>
                      <Typography variant="body1" fontWeight="500">
                        When switching Headline or Banner Image to Inherited
                        mode, values will be displayed only after saving.
                      </Typography>
                    </Box>
                  </Box>
                }
              />
            </Stack>
            {/* new Edit page meta structture */}
            <Box>
              {devices.map((device) => {
                const headlineKey = `${device}Headline` as keyof SwitchStates;
                const imageKey = `${device}Image` as keyof SwitchStates;
                const isImageUploaded =
                  device === "desktop"
                    ? bannerImagePathDesktop
                    : device === "mobile"
                    ? bannerImagePathMobile
                    : bannerImagePathTablet;
                return (
                  <Grid container spacing={2} mt={2} key={device}>
                    <Grid size={12}>
                      <Typography fontWeight={500}>
                        {device.charAt(0).toUpperCase() + device.slice(1)}:
                      </Typography>
                    </Grid>

                    <Grid size={12}>
                      <Box display="flex" width="100%">
                        {/* Headline Section */}
                        <Box flex={1} pr={1}>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            mb={1}
                          >
                            <Typography>Second Headline:</Typography>
                            <Typography>Inherited</Typography>
                            <FormControlLabel
                              control={
                                <Switch
                                  color="secondary"
                                  checked={switchStates[headlineKey]}
                                  onChange={handleToggle(headlineKey)}
                                />
                              }
                              label="Custom"
                            />
                          </Stack>

                          {switchStates[headlineKey] ? (
                            <TextField
                              id={`custom-headline-${device}`}
                              label="Custom Headline"
                              placeholder={`New ${device} headline`}
                              onChange={(e) =>
                                handleTextChange(device, e.target.value)
                              }
                              fullWidth
                              color="secondary"
                              size="small"
                              disabled={headlineState[device] === "inherit"}
                              value={
                                headlineState[device] === "custom"
                                  ? headlineCustomValue[device]
                                  : ""
                              }
                              InputLabelProps={{ shrink: true }}
                            />
                          ) : (
                            <Stack
                              direction="row"
                              justifyContent="space-between"
                              alignItems="flex-start"
                              width="100%"
                            >
                              <Stack>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Inherited Headline
                                </Typography>
                                <Typography variant="subtitle1">
                                  {headlineState[device] === "inherit"
                                    ? pageContent?.headlines?.[`${device}`] ||
                                      "N/A"
                                    : "N/A"}
                                </Typography>
                              </Stack>
                              <Stack textAlign="right">
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Inherit From
                                </Typography>
                                <Typography variant="subtitle1">
                                  {bannerState[device] === "inherit"
                                    ? pageContent?.banners?.[
                                        `${device}_inheritance`
                                      ]?.trim() || "N/A"
                                    : "N/A"}
                                </Typography>
                              </Stack>
                            </Stack>
                          )}
                        </Box>

                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ mx: 1 }}
                        />

                        {/* Image Section */}
                        <Box flex={1} pl={1}>
                          <Stack spacing={1} mb={1}>
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={1}
                            >
                              <Typography>Banner Image:</Typography>
                              <Typography>Inherited</Typography>
                              <FormControlLabel
                                control={
                                  <Switch
                                    color="secondary"
                                    checked={switchStates[imageKey]}
                                    onChange={handleToggle(imageKey)}
                                  />
                                }
                                label="Custom"
                              />
                            </Stack>

                            {switchStates[imageKey] ? (
                              <TextField
                                id={`custom-headline-${device}`}
                                placeholder={`New ${device} banner image`}
                                onChange={(e) =>
                                  handleTextChange(device, e.target.value)
                                }
                                fullWidth
                                color="secondary"
                                size="small"
                                value={isImageUploaded}
                                disabled
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      {!isImageUploaded ? (
                                        <>
                                          <input
                                            aria-label="upload picture"
                                            accept="image/*"
                                            style={{ display: "none" }}
                                            id={`file-upload-${device}`}
                                            type="file"
                                            onChange={(e) => {
                                              setUploadingDevice(device);
                                              handleFileUpload(device, e);
                                            }}
                                            disabled={
                                              bannerState[device] === "inherit"
                                            }
                                          />
                                          <label
                                            htmlFor={`file-upload-${device}`}
                                          >
                                            <IconButton
                                              disabled={
                                                bannerState[device] ===
                                                "inherit"
                                              }
                                              component="span"
                                            >
                                              <FileUploadOutlinedIcon
                                                color={
                                                  bannerState[device] ===
                                                  "inherit"
                                                    ? "disabled"
                                                    : "secondary"
                                                }
                                              />
                                            </IconButton>
                                          </label>
                                        </>
                                      ) : (
                                        <IconButton
                                          onClick={() => {
                                            if (device === "desktop")
                                              setBannerImagePathDesktop("");
                                            if (device === "mobile")
                                              setBannerImagePathMobile("");
                                            if (device === "tablet")
                                              setBannerImagePathTablet("");
                                          }}
                                        >
                                          <ClearIcon color="secondary" />
                                        </IconButton>
                                      )}
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            ) : (
                              <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="flex-start"
                                width="100%"
                              >
                                <Stack>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Inherited Banner
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    {bannerState[device] === "inherit"
                                      ? pageContent?.banners?.[
                                          `${device}`
                                        ]?.trim()
                                        ? pageContent.banners[`${device}`]
                                            .split("/")
                                            .pop()
                                        : "N/A"
                                      : "N/A"}
                                  </Typography>
                                </Stack>
                                <Stack textAlign="right">
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    Inherit From
                                  </Typography>
                                  <Typography variant="subtitle1">
                                    {bannerState[device] === "inherit"
                                      ? pageContent?.banners?.[
                                          `${device}_inheritance`
                                        ]?.trim() || "N/A"
                                      : "N/A"}
                                  </Typography>
                                </Stack>
                              </Stack>
                            )}
                          </Stack>
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                );
              })}
            </Box>
          </DialogContent>
        </Box>
        <Box>
          <DialogActions sx={{ padding: "0px 24px 24px" }}>
            <Button color="secondary" onClick={handleCancel}>
              <Stack flexDirection={"row"} gap={1}>
                Cancel
              </Stack>
            </Button>
            <Button
              color="secondary"
              onClick={() => setMetaUpdateStart(true)}
              variant="contained"
              data-tracker="29"
            >
              <Stack flexDirection={"row"} gap={1}>
                Save Changes <SaveOutlinedIcon />
              </Stack>
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  );
}
